import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
import AbstractTextElement from 'UIComponents/elements/AbstractTextElement'; // From MDN: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions

const escapeRegExp = str => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
};

const InputHighlighter = ({
  text,
  value
}) => {
  if (!value) {
    return /*#__PURE__*/_jsx(Fragment, {
      children: text
    });
  }

  const parts = text ? text.split(new RegExp(`(${escapeRegExp(value)})`, 'gi')) : [];
  return /*#__PURE__*/_jsx(Fragment, {
    children: parts.map((part, index) => /*#__PURE__*/_jsx(AbstractTextElement, {
      weight: part.toLowerCase() === value.toLowerCase() ? 'bold' : 'regular',
      children: part
    }, index))
  });
};

export default InputHighlighter;